// @flow
import type {StoreState} from "../../../reducers/combinedReducers";
import type {
    PhotoEBadgeSearchCriteria,
    PhotoEBadgeSearchFormDispatchProps,
    PhotoEBadgeSearchFormStateProps
} from "../../../components/ebadge/photo/PhotoEBadgeSearchForm";
import PhotoEBadgeSearchForm from "../../../components/ebadge/photo/PhotoEBadgeSearchForm";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {
    photoEBadgeQueryAction,
    photoEBadgeQueryStartAction,
    photoEBadgeQuerySuccessAction
} from "../../../actions/ebadge/photo/creators/photoEBadgeQueryActionCreator";
import {reset} from "redux-form";

function mapStateToProps(state: StoreState): PhotoEBadgeSearchFormStateProps {

    return {
        fairConfigs: state.fairConfigs.list,
        isLoading: state.photoEBadgeQuery.isLoading
    };
}

function mapDispatchToProps(dispatch: Dispatch): PhotoEBadgeSearchFormDispatchProps {

    return {
        onFormSubmit: (criteria: PhotoEBadgeSearchCriteria) => {
            criteria.page = 1;
            dispatch(photoEBadgeQueryAction(criteria));
        },
        clearResult: () => {
            dispatch(reset('PhotoEBadgeSearchForm'));
            dispatch(photoEBadgeQueryStartAction({page: 0}));
            dispatch(photoEBadgeQuerySuccessAction([], -1))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoEBadgeSearchForm);


// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/PhotoEBadgeSearchForm.js